import { createPinia } from 'pinia'

const pinia = createPinia()

// Track every instantiated store so logout can wipe the whole state tree
// with the built-in $reset (replaces the old global reset plugin).
const registered = new Set()
pinia.use(({ store }) => {
  registered.add(store)
})

export function resetAllStores() {
  for (const store of registered) {
    store.$reset()
  }
}

// Cypress sets its own flag; Playwright does not, so dev builds expose the
// handle too. Never shipped: import.meta.env.DEV is false in every build.
if (window.Cypress || import.meta.env.DEV) {
  // E2E handle: Playwright specs reach any active store by id, e.g.
  // window.__stores__('aiAgent').pushMessage(...)
  window.__stores__ = id => [...registered].find(s => s.$id === id)

  // Back-compat for older specs that use the commit-style handle: reads go
  // through __store__.state.<id>, writes through __store__.commit('<id>/<action>').
  window.__store__ = {
    get state() {
      return Object.fromEntries([...registered].map(s => [s.$id, s]))
    },
    commit(type, payload) {
      const [id, action] = type.split('/')
      const store = window.__stores__(id)
      if (store && typeof store[action] === 'function') {
        store[action](payload)
      }
    }
  }
}

export default pinia
